import React from 'react';
import { Card } from '@/components/ui/card';
import { cn } from '@/lib/utils';

export function KpiCard({ label, value, sub, icon: Icon, accent = false, testId }) {
  return (
    <Card data-testid={testId} className="card-hover p-4 md:p-5 border bg-card">
      <div className="flex items-start justify-between gap-3">
        <div className="text-xs font-medium text-muted-foreground uppercase tracking-wide">{label}</div>
        {Icon && (
          <div className={cn('h-8 w-8 rounded-lg grid place-items-center', accent ? 'bg-[hsl(var(--role-accent)/0.12)] text-[hsl(var(--role-accent))]' : 'bg-muted text-muted-foreground')}>
            <Icon className="h-4 w-4" />
          </div>
        )}
      </div>
      <div className="mt-2 text-2xl md:text-3xl font-semibold font-display tabular-nums" data-testid={testId ? `${testId}-value` : undefined}>
        {value}
      </div>
      {sub && <div className="mt-1 text-xs text-muted-foreground">{sub}</div>}
    </Card>
  );
}
